const $ = window.$;
export const showValidationError = (obj, msg) => {
    let errLength = $(obj).parent().find(".error_reg").length;
    if (errLength === 0) {
        $(obj).parent().append('<div class="error_reg"><font color="#cc0000">' + msg + '</font></div>');
        //$(obj).css("border-color", "red");
    }
    if (errLength === 1) {
        $(obj).parent().find(".error_reg font").html(msg);
    }
}
export const hideValidationError = (obj) => {
    $(obj).parent().find(".error_reg").remove();
    //$(obj).css("border-color", "");
}
export const runValidation = (sectionClass = "") => {
    let flag = true,
        blockClass = "";
    if (sectionClass !== "") {
        blockClass = '.' + sectionClass;
    }
    
    $(blockClass + '.required:visible, input[type="hidden"]' + blockClass + '.required').each(function (i, obj) {
        // let select_val = $(this).val();
        // if ((select_val.indexOf('m') > -1) || (select_val.indexOf('l') > -1)) { 
        //     if (select_val.indexOf('-') > -1) {
        //         hideValidationError(obj);
        //     } else {
        //         let errMsg = $(this).attr("data-error-required") || "Please answer.";
        //         showValidationError(obj, errMsg);
        //         flag = false;
        //     }
        // } else {
        //     var count = select_val.split("-").length;
        //     var count1 = count-1;
        //     if(count1 < 6) {
        //         let errMsg = $(this).attr("data-error-required") || " Please answer.";
        //         showValidationError(obj, errMsg);
        //         flag = false;
        //     } else {
        //         hideValidationError(obj);
        //     }
        // }
        if ($(this).parent().is(':visible') && ($.trim($(this).val()) == "" || $(this).val() == "Select" || $(this).val().indexOf("Select") >= 0)) {
            let select_val = $(this).val();
            
            if(select_val == ""){
                let errMsg = $(this).attr("data-error-required") || "Please answer.";
                showValidationError(obj, errMsg);
                flag = false;
            }
            // let errMsg = $(this).attr("data-error-required") || "Please answer.";
            // showValidationError(obj, errMsg);
            // flag = false;
        } else {
            hideValidationError(obj);
        }
    });

    $('textarea' + blockClass + ', input' + blockClass).each(function (i, obj) {
        /* The rules must has input value goes here */
        if ($(this).val() != undefined && $.trim($(this).val()) != "") {
            if ($(this).hasClass('alpha')) {
                if (!$(this).val().match(/^[A-Za-z ]+$/)) {
                    showValidationError(obj, "* This field may contain only alphabets.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('digit')) {
                if (!$(this).val().match(/^[0-9]+$/)) {
                    showValidationError(obj, "* Enter valid positive number.");
                    flag = false;
                } else if ($(this).attr("data-minvalue") && $(this).attr("data-maxvalue") && !(parseInt($(this).val()) >= parseInt($(this).attr("data-minvalue")) && parseInt($(this).val()) <= parseInt($(this).attr("data-maxvalue")))) {
                    showValidationError(obj, "* The number must be between " + $(this).attr("data-minvalue") + " to " + $(this).attr("data-maxvalue"));
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('numeric')) {
                if (isNaN($(this).val())) {
                    showValidationError(obj, "* Enter numeric value.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('alphanumeric')) {
                if (!$(this).val().match(/^[A-Za-z0-9]+$/)) {
                    showValidationError(obj, "* Enter alphanumeric value.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('alphanumericspace')) {
                if (!$(this).val().match(/^[ .?A-Za-z0-9]+$/)) {
                    showValidationError(obj, "* Enter alphanumeric value.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('onlyalphanumeric')) {
                if (!$(this).val().match(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/)) {
                    showValidationError(obj, "* Entered value must contain alphanumeric.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('email')) {
                let regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!regEx.test($(this).val())) {
                    showValidationError(obj, "* Enter valid email address.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('minlength')) {
                if ($(this).val().length < $(this).attr("minlength")) {
                    showValidationError(obj, "* Minimum " + $(this).attr("minlength") + " characters required.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('maxlength')) {
                if ($(this).val().length > $(this).attr("maxlength")) {
                    showValidationError(obj, "* Maximum " + $(this).attr("maxlength") + " characters only allowed.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('pincode')) {
                if (!$(this).val().match(/^[0-9]+$/) || $(this).val().length <= 5 || $(this).val().length > 6) {
                    showValidationError(obj, "* Only number with 5-6 digits are allowed.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('age')) {
                if (!$(this).val().match(/^[0-9]+$/) || $(this).val() < 1 || $(this).val() > 120) {
                    showValidationError(obj, "* Age must be number and between 1-120.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('sequence')) {
                let tempArr = [],
                    seqSegments = $(this).val().split("-"),
                    maxSeqNum = parseInt($(this).attr("data-max-seq"));
                for (let i = 0; i < seqSegments.length; i++) {
                    if (seqSegments[i].match(/^[0-9]+$/) && $.inArray(seqSegments[i], tempArr) < 0) {
                        tempArr.push(seqSegments[i]);
                    }
                }
                if (tempArr.length !== maxSeqNum || Math.min.apply(Math, tempArr) <= 0 || Math.max.apply(Math, tempArr) > maxSeqNum) {
                    showValidationError(obj, "* The sequence order must be with-in 1-" + maxSeqNum + ".");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('with-in-options')) {
                let options = $(this).attr("data-options").split(",");
                if ($.inArray($.trim($(this).val()), options) < 0) {
                    showValidationError(obj, "* The entered value must be with-in above options.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
            if ($(this).hasClass('word-count-check')) {
                let maxWords = parseInt($(this).attr("data-total-words")),
                    totWords = $.trim($(this).val()).split(/\s+/);
                if (totWords.length > maxWords) {
                    showValidationError(obj, "* You have exceeded the maximum word limit. Please rephrase the contents to fit within the word limit specified.");
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
        }
        /* The rules that does not depend on user input value goes here */
        if ($(this).hasClass('minmaxdate')) {
            let minDate = $($(this).attr("data-mindate")).val(),
                maxDate = $($(this).attr("data-maxdate")).val();
            if (minDate != undefined && minDate != "" && maxDate != undefined && maxDate != "") {
                let minDate = new Date(minDate),
                    maxDate = new Date(maxDate);
                if (minDate > maxDate) {
                    let errMsg = $(this).attr("data-error-minmaxdate") || "End date should not be lesser than start date.";
                    showValidationError(obj, errMsg);
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
        }
        if ($(this).hasClass('rangedate')) {
            let minDate = $($(this).attr("data-mindate")).val(),
                maxDate = $($(this).attr("data-maxdate")).val(),
                rangeDate = $($(this).attr("data-rangedate")).val();
            if (rangeDate != undefined && rangeDate != "" && minDate != undefined && minDate != "" && maxDate != undefined && maxDate != "") {
                let minDate = new Date(minDate),
                    maxDate = new Date(maxDate),
                    rangeDate = new Date(rangeDate);
                if (rangeDate < minDate || rangeDate > maxDate) {
                    let errMsg = $(this).attr("data-error-rangedate") || "Date should be between minimum and maximum date.";
                    showValidationError(obj, errMsg);
                    flag = false;
                } else {
                    hideValidationError(obj);
                }
            }
        }
    });
    if (!flag) {
        $('html, body').animate({
            scrollTop: $("div.error_reg:visible").parent().offset().top - 200
        }, 500);
    }
    return flag;
}



// WEBPACK FOOTER //
// ./src/helpers/Validation.js